export default __webpack_public_path__ + "static/media/remove-circle-outline.c4e1292e.svg";